module.exports = __webpack_public_path__ + "public/img/image-6.495cf7c4.png";